<template>
    <div style="
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
     display: flex;
     flex-direction: column;
  
     align-items: center;
    " :style="{
        background: 'url(' + require('../assets/bg.png') + ')',
        backgroundSize: 'cover'
    }">
        <div style="display: flex;align-items: center;justify-content: center;margin: 10% 0; ">
            <img src="../assets/logo.png" style="width: 80px;height: 80px;" alt="">

            <img src="../assets/word.png" style="width: 150px;height: 40px;margin-top: 30px;" alt="">
        </div>
        <div style="display: flex;align-items: center;width: 90%;border-bottom: #FC5531 solid 1px;">
            <input v-model="phoneNumber" type="text" style="flex: 1;background: transparent;outline: 0;border: 0;"
                placeholder="请输入手机号码">
        </div>
        <div style="display: flex;align-items: center;width: 90%;border-bottom: #FC5531 solid 1px;margin: 10px 0;">
            <input v-model="checkCode" type="text" style="flex: 1;background: transparent;outline: 0;border: 0;"
                placeholder="请输入验证码">
            <div @click="PostCheckCode" v-if="posting == false" style="color: #FC5531;cursor: pointer;">获取验证码</div>
            <div v-if="posting == true" style="color: grey;cursor: pointer;">已发送({{ counter }})</div>
        </div>
        
        <div style="display:flex;align-items: center;">
            <input type="radio" />
            我已阅读并同意<a @click.prevent="$router.push('/userAgreement')" href="https://www.baidu.com" target="_blank">《乘风快购用户协议》</a>和<a @click.prevent="$router.push('/privacyPolicy')" href="https://www.baidu.com"
                target="_blank">《隐私政策》</a>
        </div>

        <button @click="login"
            style="width: 90%;padding: 10px 0;margin-top: 30px;background: linear-gradient(to right, #FCBC23, #FC5531);color: white;border: 0;">登录</button>
        <div style="width: 100%;margin: 20px 0;" :style="{
            height: $store.state.indexBarHeight + 'px'
        }">
            <a href="https://beian.miit.gov.cn/" target="_blank">ICP备案号</a>
            <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2026080515号-2</a>
        </div>
    </div>
</template>

<script>
import request from "../axios/request";
export default {
    data() {
        return {
            posting: false,
            counter: 60,
            phoneNumber: '',
            checkCode: ''
        }
    },
    methods: {
        RegisterUserWs() {
            let mes = {
                op: "initCurrent",
                sendToken: localStorage.getItem("token"),
                senderType: 0
            }
            this.$store.commit("sendMessage", JSON.stringify(mes))
        },
        async login() {
            let res = await request({
                url: "/user/api/login",
                method: "POST",
                data: {
                    phoneNumber: this.phoneNumber,
                    checkCode: this.checkCode
                }
            })
            if (res.data.status == 200) {
                localStorage.setItem("token", res.data.data);
                const paymentReturn = sessionStorage.getItem('webPaymentReturn');
                if (paymentReturn && /^\/cashier\/\d+(\?[^#]*)?$/.test(paymentReturn)) {
                    sessionStorage.removeItem('webPaymentReturn');
                    this.$router.replace(paymentReturn);
                    await this.$store.dispatch("getUserInfoByToken");
                    this.RegisterUserWs();
                    return;
                }
                const postLoginRedirect = sessionStorage.getItem('postLoginRedirect');
                if (postLoginRedirect || this.$route.query.redirect === 'real-name') {
                    sessionStorage.removeItem('postLoginRedirect');
                    window.location.replace('/real-name.html?source=official#token=' + encodeURIComponent(res.data.data) + '&source=official');
                    return;
                }
                const bindTicket = this.$route.query.officialBindTicket || sessionStorage.getItem('officialBindTicket') || null;
                if (bindTicket) {
                  const bind = await request({ url: "/wechat/official/oauth/bind", method: "POST", data: { ticket: bindTicket } });
                  if (bind.data.status != 200) {
                    this.$message.error(bind.data.desc || "服务号账号绑定失败");
                    return;
                  }
                  if (bind.data.data && bind.data.data.bound) {
                    sessionStorage.removeItem('officialBindTicket');
                    window.location.replace('/real-name.html#token=' + encodeURIComponent(res.data.data) + '&source=official');
                    return;
                  }
                }
                this.$router.push("/");
                await this.$store.dispatch("getUserInfoByToken")
                this.RegisterUserWs()
            }
        },
        async PostCheckCode() {
            let res = await request({
                url: "/user/api/postCheckCode",
                method: "POST",
                data: {
                    phoneNumber: this.phoneNumber
                }
            })
            if (res.data.status == 200) {
                this.posting = true
                const timer = setInterval(() => {
                    this.counter--;
                    if (this.counter <= 0) {
                        clearInterval(timer);
                        this.posting = false
                        this.counter = 60
                        // 此处可添加倒计时结束后的逻辑
                    }
                }, 1000); // 每秒更新一次
            }

        }
    }
}
</script>

<style scoped></style>
